<template>
  <b-modal id="custom" title="custom" hide-footer>
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row my-4">
            <div class="col-12 text-center">
              <!-- if any image -->
            </div>
            <div class="col-12 text-center my-4">
              <!-- text here -->
            </div>
            <div class="col-12">
              <!-- button -->
              <!-- <button class="btn btn-primary w-100">DONE</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/components/modals/custom.vue